import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { messageSchema } from './schemas/message-schema';
import { vehiclesSchema } from './schemas/vehicle.schema';

export function getVehicleGroupsVehicles(vehicleGroupId: number) {
  return fromFetch(
    new Request(
      fleetEnvironment.vehicleGroupsVehiclesUrl(String(vehicleGroupId)),
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
      }
    )
  ).pipe(
    selectData(
      messageSchema.extend({
        data: vehiclesSchema,
      })
    )
  );
}
